import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { ICON_MISC_PAYMENT_OK } from '@bwoty-web/ui-kit/icons';
import LinkPush from './linkPush';
import './partialPayment.scss';

const PartialPayment = ({ labels }) => {
  return (
    <LinkPush
      href={labels?.partialPaymentLink?.href?.url}
      onClick={() =>
        window.dataLayer.push({
          event: 'partial_payment_link_click',
        })
      }
      target={labels?.partialPaymentLink?.href?.target || '_self'}
    >
      <Icon path={ICON_MISC_PAYMENT_OK} size="m" />
      <span>{labels.partialPaymentLink?.title}</span>
    </LinkPush>
  );
};

PartialPayment.propTypes = {
  labels: PropTypes.shape({
    partialPaymentLink: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.shape({
        url: PropTypes.string,
        target: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default PartialPayment;
